var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "workOrder" },
    [
      _c("div", { staticClass: "tabNav" }, [
        _c(
          "span",
          {
            staticClass: "build",
            class: { activeTab: _vm.activeColor == 1 },
            on: {
              click: function($event) {
                return _vm.changeTab(1)
              }
            }
          },
          [_vm._v("我创建的")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "recive",
            class: { activeTab: _vm.activeColor == 2 },
            on: {
              click: function($event) {
                return _vm.changeTab(2)
              }
            }
          },
          [_vm._v("我受理的")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "serch-wrap" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.orderForm }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "工单类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.orderForm.type,
                        callback: function($$v) {
                          _vm.$set(_vm.orderForm, "type", $$v)
                        },
                        expression: "orderForm.type"
                      }
                    },
                    _vm._l(_vm.typeList, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { value: item.value, label: item.label }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "工单状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.statusArr,
                        callback: function($$v) {
                          _vm.statusArr = $$v
                        },
                        expression: "statusArr"
                      }
                    },
                    _vm._l(_vm.statusList, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { value: item.value, label: item.label }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "key-form", attrs: { label: "关键字" } },
                [
                  _c("el-input", {
                    staticClass: "key-input",
                    model: {
                      value: _vm.order_keyContent,
                      callback: function($$v) {
                        _vm.order_keyContent = $$v
                      },
                      expression: "order_keyContent"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "key-select",
                      attrs: { clearable: "", placeholder: "请选择" },
                      on: { change: _vm.selectChange },
                      model: {
                        value: _vm.order_key,
                        callback: function($$v) {
                          _vm.order_key = $$v
                        },
                        expression: "order_key"
                      }
                    },
                    _vm._l(_vm.keyList, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "create-time", attrs: { label: "创建时间" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期"
                    },
                    on: { focus: _vm.focusTime },
                    model: {
                      value: _vm.date,
                      callback: function($$v) {
                        _vm.date = $$v
                      },
                      expression: "date"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.searchOrderList }
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.resetOrder }
                    },
                    [_vm._v("重置")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "add-but" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function($event) {
                  return _vm.handleAdd()
                }
              }
            },
            [_vm._v("新建")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "custom-class": "work-create-dialog",
            title: "创建工单",
            "append-to-body": "",
            center: "",
            visible: _vm.isShowAdd,
            top: "250px",
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowAdd = $event
            },
            close: _vm.closeAdd
          }
        },
        [
          _c("div", { staticClass: "exportbtnbox" }, [
            _c(
              "div",
              { staticClass: "box1" },
              [
                _c("i", [_vm._v("*")]),
                _c("span", { staticStyle: { width: "65px" } }, [
                  _vm._v("来源单号")
                ]),
                _vm._v(" "),
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    autosize: "",
                    resize: "none",
                    placeholder: "只能输入字母和数字(长度不超过30)",
                    onkeyup: "this.value=this.value.replace(/[^\\w_]/g,'')",
                    maxlength: "30",
                    "show-word-limit": "",
                    disabled: _vm.sourceAsMsg
                  },
                  on: { input: _vm.check },
                  model: {
                    value: _vm.build.businessKey,
                    callback: function($$v) {
                      _vm.$set(_vm.build, "businessKey", $$v)
                    },
                    expression: "build.businessKey"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "box2" }, [
              _c("i", [_vm._v("*")]),
              _c("span", [_vm._v("问题类型")]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("el-cascader", {
                    staticClass: "cascader",
                    attrs: {
                      options: _vm.options,
                      clearable: "",
                      filterable: "",
                      placeholder: "请选择问题类型"
                    },
                    on: { change: _vm.handleChange },
                    model: {
                      value: _vm.build.problemTypes,
                      callback: function($$v) {
                        _vm.$set(_vm.build, "problemTypes", $$v)
                      },
                      expression: "build.problemTypes"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-tooltip", { attrs: { placement: "top" } }, [
                    _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                      _c("div", [_vm._v(_vm._s(_vm.descPrompt))])
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "el-icon-question pointer" })
                  ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box1 box-descript" },
              [
                _c("i", [_vm._v("*")]),
                _c(
                  "span",
                  { staticStyle: { width: "65px", "margin-left": "2px" } },
                  [_vm._v("问题描述")]
                ),
                _vm._v(" "),
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    rows: 3,
                    placeholder:
                      "请输入实物型号、品牌、（实收）数量、商品现状描述、具体破损位置、不符合退换原因、客户姓名地址手机号、承运商、收费价格及原因"
                  },
                  model: {
                    value: _vm.build.description,
                    callback: function($$v) {
                      _vm.$set(_vm.build, "description", $$v)
                    },
                    expression: "build.description"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box-img" },
              [
                _c("span", [_vm._v("上传图片")]),
                _vm._v(" "),
                _c(
                  "el-upload",
                  {
                    staticClass: "img-upload",
                    attrs: {
                      action: _vm.addImgUrl,
                      headers: _vm.headers,
                      "list-type": "picture-card",
                      "auto-upload": true,
                      limit: 5,
                      "before-upload": _vm.beforeAvatarUpload,
                      "on-success": _vm.successImg,
                      "file-list": _vm.fileList,
                      "on-exceed": _vm.exce
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "file",
                        fn: function(ref) {
                          var file = ref.file
                          return _c("div", {}, [
                            _c("img", {
                              staticClass: "el-upload-list__item-thumbnail",
                              attrs: { src: file.url, alt: "" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "el-upload-list__item-actions" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "el-upload-list__item-preview",
                                    on: {
                                      click: function($event) {
                                        return _vm.handlePictureCardPreview(
                                          file
                                        )
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "el-icon-zoom-in" })]
                                ),
                                _vm._v(" "),
                                !_vm.build.disabled
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "el-upload-list__item-delete",
                                        on: {
                                          click: function($event) {
                                            return _vm.handleRemove(file)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        }
                      }
                    ])
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-plus",
                      attrs: { slot: "default" },
                      slot: "default"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-dialog",
                  {
                    attrs: { visible: _vm.build.dialogVisible },
                    on: {
                      "update:visible": function($event) {
                        return _vm.$set(_vm.build, "dialogVisible", $event)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        width: "100%",
                        src: _vm.build.dialogImageUrl,
                        alt: ""
                      }
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "img-info" }, [
              _vm._v("（最多支持上传5张）")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box-img" },
              [
                _c("span", [_vm._v("上传视频")]),
                _vm._v(" "),
                _c(
                  "el-upload",
                  {
                    staticClass: "img-upload video-upload",
                    attrs: {
                      action: _vm.addVideoUrl,
                      headers: _vm.headers,
                      "list-type": "picture-card",
                      "auto-upload": true,
                      limit: 3,
                      "before-upload": _vm.beforeAvatarUploadVideo,
                      "on-success": _vm.successVideo,
                      "file-list": _vm.videoList,
                      "on-exceed": _vm.exceVideo
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "file",
                        fn: function(ref) {
                          var file = ref.file
                          return _c("div", {}, [
                            _c(
                              "video",
                              {
                                staticClass: "avatar video-avatar",
                                staticStyle: { width: "100%" },
                                attrs: { src: file.url, controls: "controls" }
                              },
                              [
                                _vm._v(
                                  "\n              您的浏览器不支持视频播放\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "el-upload-list__item-video" },
                              [
                                !_vm.build.disabled
                                  ? _c(
                                      "span",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.handleRemoveVideo(file)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-error",
                                          staticStyle: {
                                            color: "#333",
                                            cursor: "pointer"
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        }
                      }
                    ])
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-plus",
                      attrs: { slot: "default" },
                      slot: "default"
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "img-info" }, [
              _vm._v("（最多支持上传3个视频）")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "add-margin" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "button-bg-color",
                    attrs: { type: "primary" },
                    on: { click: _vm.saveAdd }
                  },
                  [_vm._v("提 交")]
                ),
                _vm._v(" "),
                _c("el-button", { on: { click: _vm.closeAdd } }, [
                  _vm._v("取 消")
                ])
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: { "max-height": "600", data: _vm.tableData }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "createdAt", label: "创建时间" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "exceptionOrderNo", label: "工单号", width: "180" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "exceptionTypeDesc", label: "工单类型" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "statusDesc", label: "工单状态" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "createdByName", label: "创建人" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "operatorName", label: "受理人" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "rejectOrder",
                        class:
                          scope.row.exceptionOrderNo === _vm.exceptionOrderNo
                            ? "isActive"
                            : "noActive",
                        attrs: { type: "text" },
                        on: {
                          click: function($event) {
                            return _vm.getOrderDetail(scope.row)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.totalElements
        ? _c("el-pagination", {
            attrs: {
              "page-size": _vm.size,
              "current-page": _vm.page,
              "page-sizes": [10, 20, 50, 100],
              "pager-count": 11,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.totalElements
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-edc96176", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edc96176","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/orderForChat/workOrder.vue
// module id = null
// module chunks = 